/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Localized from '../../../../shared/components/Localized';
import { CustomIcon } from '../../../components/SVGIcon';
import Button from '../../../components/Button';

import styles from '../../../styles';

const Wrapper = styled.div`
  padding: 1rem;
  background-color: ${styles.colors.linkWater};
  border-radius: .25rem;
  display: flex;

  @media (max-width: 767px) {
    padding: 1.25rem;
  }

  @media (max-width: 610px) {
    flex-wrap: wrap;
  }
`;

const Icon = styled.div`
  padding-right: 1rem;
`;

const HideOnSmallScreen = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

const MoveRightHideOnSmallScreen = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 0.5rem;

  @media (max-width: 767px) {
    display: none;
  }
`;

const Label = styled.span`
  font-size: 13px;
  color: #16325C;
  margin-right: 1rem;

  > span {
    margin-left: .25rem;
  }
`;

const Link = styled.a`
  ${styles.fonts.linkResults}
`;

const Heading = styled.span`
  ${styles.fonts.headingMedium}
`;

const ButtonWrapper = styled.div`
  ${Button} + ${Button} {
    margin-left: 0.75rem;
    @media (max-width: 767px) {
      float: right;
    }
  }
  @media (max-width: 767px) {
    margin-top: 1rem;
  }
`;

const LeftWrapper = styled.div`
  margin-left: auto;
  @media (max-width: 767px) {
    margin-left: 0;
    display: flex;
    width: 100%;
  }
`;

const Header = ({ subscriber, locales, onSubscribeClick, onUnsubscribeClick, onLocaleChange, selectedLocale, changingLocale, logout }) => {
  let count = _.uniqBy(subscriber.Subscriptions, 'instanceKey').length;
  if (subscriber.generalMessageEmailSubscribed || subscriber.generalMessageSMSSubscribed) {
    count += 1;
  }

  return <Wrapper>
    <Icon>
      <CustomIcon icon='custom53' bgColor='#2ecbbe' size='3rem' round />
    </Icon>
    <div>
      <Heading><Localized
        modelKey='mySubscription'
        modelAttribute='userOptions'
        modelName='iconDropdownMenu' /></Heading>
      <div>	
      <Label>{ count } 
        <Localized	
          modelKey='items'	
          modelAttribute='label'	
          modelName='subscriptions' />
      </Label>	
    </div>
    </div>
    <LeftWrapper>
      <MoveRightHideOnSmallScreen>
        <Label>
          { subscriber.emailAddress }
        </Label>
        <Link onClick={logout}>
          Logout
        </Link>
      </MoveRightHideOnSmallScreen>
      <ButtonWrapper>
        <Button
          theme='destructive-inverse'
          onClick={onUnsubscribeClick}
          disabled={subscriber.Subscriptions.length === 0 && subscriber.generalMessageEmailSubscribed == false && subscriber.generalMessageSMSSubscribed == false}
        ><Localized
        modelKey='unsubscribeall'
        modelAttribute='label'
        modelName='button' /></Button>
        <Button theme='brand' onClick={onSubscribeClick}>Create New</Button>
      </ButtonWrapper>
    </LeftWrapper>
  </Wrapper>;
};

export default Header;


